export default {
  USD: '$',
  EUR: '€',
  AED: 'د.إ',
  ALL: 'L',
  AMD: 'Դ',
  ARS: '$',
  AUD: 'A$',
  AZN: '₼',
  BDT: '৳',
  BGN: 'Лв',
  BMD: '$',
  BRL: 'R$',
  CAD: 'C$',
  CDF: 'FC',
  CHF: '₣',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  CRC: '₡',
  CZK: 'Kč',
  DKK: 'Kr.',
  GBP: '£',
  GEL: '₾',
  GHS: 'GH¢',
  GTQ: 'Q',
  HKD: 'HK$',
  HRK: 'kn‎',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'Íkr',
  JPY: '¥‎',
  KES: '/=',
  KGS: 'Лв',
  KRW: '₩',
  KWD: 'د.ك',
  KYD: '$',
  KZT: '₸',
  MAD: 'MAD',
  MDL: 'L',
  MKD: 'Ден',
  MMK: 'K',
  MNT: '₮',
  MXN: 'Mex$',
  MYR: 'RM',
  NAD: 'N$',
  NGN: '₦',
  NOK: 'kr',
  NZD: '$',
  PEN: 'S/',
  PLN: 'zł',
  PYG: '₲',
  RON: 'lei',
  RUB: '₽',
  SAR: '﷼‎',
  SEK: 'kr',
  SGD: 'S$',
  SLL: 'Le',
  THB: '฿',
  TMT: 'T',
  TND: 'د.ت',
  TRY: '₺',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  UYU: '$U',
  UZS: "so'm",
  VND: '₫',
  XAF: 'FCFA',
  XOF: 'CFA',
  ZAR: 'R',
  ZMW: 'ZK',
  BAM: "BAM",
  PHP: "₱",
  BYN: "BYN",
  BTC: 'BTC',
  ETH: 'ETH',
  DOG: 'DOG',
  DOGE: 'DOGE',
  XDG: 'XDG',
  USDT: 'USDT',
  LTC: 'LTC',
  BNB: 'BNB',
  USDC: 'USDC',
  mBTC: 'mBTC',
  mETH: 'mETH',
  EGP: '£',
  KHR: '₭',
  LAK: '₭',
  MVR: 'Rf',
  MBC: 'mBTC',
  FTN: 'FTN',
  IRT: 'IRT',
  MBT: 'mBT',
  TJS: 'TJS',
  SOS: 'SOS',
  SDG: 'SDG',
};
